import {Component, HostListener, ViewChild, AfterViewInit, AfterViewChecked, AfterContentInit, ChangeDetectorRef } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { Router } from '@angular/router';
import { SearchResultsService } from './services/searchResults.service';
import { LoginService } from './services/login.service';
import { MapComponent } from './map/map.component';
import { SearchComponent } from './search/search.component';
import { LoginComponent } from './login/login.component';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { LocationResultsComponent } from './location-results/location-results.component';
import { LocationFilterComponent } from './location-filter/location-filter.component';

import {
  faArrowLeft,
  faToggleOn,
  faToggleOff,
  faUser,
  faBars,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';

import {
  faFacebook,
  faPinterest,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

import cookiesHelper from './helpers/cookies.helper';

@Component({
  selector: 'app-root',
  animations: [
    trigger(
      'pageFade', [
        transition(':enter', [
          style({opacity: 0}),
          animate('250ms', style({opacity: 1}))
        ]),
        transition(':leave', [
          style({opacity: 1}),
          animate('250ms', style({opacity: 0}))
        ])
      ]
    )
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [LoginService, SearchResultsService]
})

export class AppComponent implements AfterViewInit {
  title = 'WSNLA';
  // brandImagePath = '/assets/images/WSNLALogo.svg';
  brandImagePath = '/assets/images/wsnla-logo-new.png';
  brandImagePathLogoOnlyLeaf = '/assets/images/logo-mini.png';
  barIcon = '/assets/images/bar-icon.svg';
  closeIcon = '/assets/images/close-icon.svg';

  helpHintsOn: any = true;
  loginOverlayOn = false;
  landingPageOn = true;
  mobileNav = false;

  // Font Awesome Icons
  faArrowLeft = faArrowLeft;
  faToggleOn = faToggleOn;
  faToggleOff = faToggleOff;
  faUser = faUser;
  faBars = faBars;
  faTimes = faTimes;
  faFacebook = faFacebook;
  faPinterest = faPinterest;
  faInstagram = faInstagram;
  faYoutube = faYoutube;

  centerMapOutput: Function;
  displayDirections: Function;
  removeDirections: Function;
  showMarkersGivenIds: Function;
  showAllMarkers: Function;
  goToUserMenu: Function;
  openNursery: Function;
  openPinInfo: Function;
  getNurseryProductWithId: Function;
  logOutUser: Function;
  updateUser: Function;
  handleSearchPassSearchModel: Function;
  showAllPlants: Function;
  showNurseries: Function;
  leaveLandingPage: Function;
  refreshNurseriesAndProduct: Function;
  constructor(private loginService: LoginService, private ref: ChangeDetectorRef, private router: Router) {}

  @ViewChild(MapComponent) mapWindow: MapComponent;
  @ViewChild(SearchComponent) search: SearchComponent;
  @ViewChild(LoginComponent) login: LoginComponent;
  @ViewChild(UserMenuComponent) userMenu: UserMenuComponent;
  @ViewChild(LandingPageComponent) landingPage: LandingPageComponent;
  @ViewChild(LocationFilterComponent) locationFilter: LocationFilterComponent;
  @ViewChild(LocationResultsComponent) locationResults: LocationResultsComponent;

  @HostListener('window:resize', ['$event'])
  @HostListener('window:resize') onResize() {
    let windowWidth = window.innerWidth;
    let windowHeight = window.innerHeight;
    let heightTrim = 52; // Magic!! Cuts off top nav, need to set it up properly
    let widthTrim = 0;
    // this.mapWindow.height = windowHeight - heightTrim;
    // this.mapWindow.width = windowWidth - widthTrim;
    this.helpHintsOn = cookiesHelper.getCookie('helphint') == 'true';
    this.centerMapOutput = (location, zoom) => this.mapWindow.centerMap(location, zoom);
    this.displayDirections = (directions, start, end, routeIndex) => this.mapWindow.displayDirections(directions, start, end, routeIndex);
    this.removeDirections = () => this.mapWindow.removeDirections();
    this.showMarkersGivenIds = (nurseryIds => this.mapWindow.showMarkersGivenIds(nurseryIds));
    this.showAllMarkers = () => this.mapWindow.showAllMarkers();
    this.openNursery = (nursery => this.search.nurseryClicked(nursery));
    this.openPinInfo = (nursery => this.mapWindow.openPinInfo(nursery));
    this.getNurseryProductWithId = (id, nursery) => this.search.getNurseryProductWithId(id, nursery);
    this.logOutUser = () => this.loginService.logOut();
    this.updateUser = (userObj => this.loginService.updateUser(userObj));
    this.goToUserMenu = () => this.openUserMenu();
    this.handleSearchPassSearchModel = (searchModel) => this.search.handleSearchPassSearchModel(searchModel);
    this.showAllPlants = () => this.search.showAllProducts();
    this.showNurseries = () => this.search.showAllNurseries();
    this.leaveLandingPage = () => {
      // this.mapWindow.startMap();
      this.landingPageOn = false;
      this.mapWindow.height = windowHeight - heightTrim;
      this.mapWindow.width = windowWidth - widthTrim;
    }
    this.refreshNurseriesAndProduct = () => {
      return this.search.refreshDataSets();
    }
  }

  getProductTypes() {
    return this.search.dataSets.productTypes;
  }
  getProductionTypes() {
    return this.search.dataSets.productionTypes;
  }
  getPackagingTypes() {
    return this.search.dataSets.packagingTypes;
  }

  showAllNurseries() {
    this.search.showAllNurseries();
  }
  showAllProducts() {
    this.search.showAllProducts();
  }

  plantsSearch() {
    this.showAllNurseries();
    console.log('search for plants');
    this.leaveLandingPage();
  }

  nurserySearch() {
    console.log('search for nurseries');
    this.showAllProducts();
    this.leaveLandingPage();
  }

  goHome() {
    this.search.reset();
    this.mapWindow.centerMapCurrentLocation();
    this.removeDirections();
    this.landingPageOn = true;
    this.landingPage.searchModel = '';
  }

  toggleHelpHints() {
    this.helpHintsOn = !this.helpHintsOn;
    cookiesHelper.createCookie('helphint', this.helpHintsOn);
    this.search.toggleHelpHints(this.helpHintsOn);
    this.userMenu.toggleHelpHints(this.helpHintsOn);
  }

  toggleMobileNav(show: boolean) {
    this.mobileNav = show;
  }

  userIconClicked() {
    if (this.loginService.isLoggedIn()) {
      this.openUserMenu();
    } else {
      this.login.openLogin(this.goToUserMenu);
    }
  }
  openUserMenu() {
    this.userMenu.toggleUserMenu(this.loginService.getLoggedInUser() || {}, this.search.dataSets.nurseryResults);
    this.search.toggleSideMenuOff();
  }

  navigateToWsnla() {
    if (confirm("Navigate to www.wsnla.org?") == true) {
      const win = window.open('http://www.wsnla.org/', '_blank');
      win.focus();
    }
  }

  ngAfterViewInit() {
    // this.onResize();
  }

  ngAfterContentInit() {
    this.onResize();
  }

  ngOnInit() {
    // this.mapWindow.initializeMap();
  }
}
